module.exports = __WEBPACK_EXTERNAL_MODULE_49__;


//////////////////
// WEBPACK FOOTER
// external {"root":"Vue","commonjs":"vue","commonjs2":"vue","amd":"vue"}
// module id = 49
// module chunks = 0